import React, { useRef, useState } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

const OverflowTooltip = ({ text, children }) => {
  const textRef = useRef(null)
  const [showTooltip, setShowTooltip] = useState(false)

  const checkOverflow = () => {
    if (textRef.current) {
      const isOverflowing =
        textRef.current.scrollWidth > textRef.current.clientWidth
      setShowTooltip(isOverflowing)
    }
  }
  const hideTooltip = () => {
    setShowTooltip(false)
  }

  return (
    <OverlayTrigger
      placement='top'
      overlay={<Tooltip>{text}</Tooltip>}
      show={showTooltip}
    >
      <div
        ref={textRef}
        onMouseEnter={checkOverflow}
        onMouseLeave={hideTooltip}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '100%',
        }}
      >
        {children}
      </div>
    </OverlayTrigger>
  )
}
export default OverflowTooltip
